/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { environment } from './environments/environment'
import { LanguageService } from './app/services/language.service'
import { LANGUAGE_CODES } from './app/constants/language'

const languageService = new LanguageService()

if (environment.production) {
  enableProdMode()
}

let language = languageService.getLanguageFromLS()

if (!language) {
  language = {
    name: $localize.locale === LANGUAGE_CODES.FR ? 'French' : 'English',
    code:
      $localize.locale === LANGUAGE_CODES.FR
        ? LANGUAGE_CODES.FR
        : LANGUAGE_CODES.EN,
  }
  languageService.storeLanguageInLS(language)
}
const languageRedirectUrl = languageService.getLanguageRedirectUrl(language)
if (languageRedirectUrl) {
  location.replace(languageRedirectUrl)
} else {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  }).catch((err) => console.error(err))
}
